import { Route } from 'vue-router'
import { i18n } from '@/setup/setup-i18n'
import store from '@/store'

export const setPageMeta = ({ name }: Route) => {
  const title = getLocalisedPageTitle(name)
  const suffix = store.getters['LoginDomain/themeName'] || ''
  document.title = [title, suffix].filter(x => !!x).join(' - ')
}

export const getLocalisedPageTitle = (routeName: string): string => {
  const key = `${routeName}.metaTitle`
  const title = i18n.t(key) as string

  return title === key ? null : title
}
